export default __webpack_public_path__ + "static/media/forms-white.0dc9725e.svg";